
import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const notificationsApi = baseApi.injectEndpoints({
   tagTypes: ["Notifications"],
   endpoints: (builder) => ({
      getNotifications: builder.query({
         query: (params) => {
            return {
               url: `/appointments/getNotificationList.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
         providesTags: ["Notifications"],
      }),
      readAsMark: builder.mutation({
         query: (body) => {
           return {
             url: `/appointments/markNotificationChanged.json`,
             method: "POST",
             body: body,
           };
         },
         transformResponse: (response, meta, arg) => response?.response,
       }),

   }),
});

// Export hooks for usage in functional components
export const { useGetNotificationsQuery,useReadAsMarkMutation } = notificationsApi;
